/**
 * Resolve Command Center attention / quick-action deep links.
 *
 * @param {string | undefined} actionType
 * @param {string | number | undefined} entityId
 * @returns {string}
 */
export function resolveCommandActionRoute(actionType, entityId) {
  const id = entityId != null && entityId !== '' ? String(entityId) : ''

  switch (actionType) {
    case 'prepare_room':
    case 'review_cancel':
      return id ? `/calendar?appointment=${id}` : '/calendar'
    case 'collect_payment':
      return '/pos'
    case 'call_guest':
      return id ? `/masters/customers?highlight=${id}` : '/masters/customers'
    case 'view_stock':
      return id ? `/inventory?product=${id}` : '/inventory'
    default:
      return '/'
  }
}

/** @type {ReadonlyArray<{ label: string, route: string }>} */
export const COMMAND_QUICK_ACTIONS = [
  { label: 'New booking', route: '/calendar?book=1' },
  { label: 'POS', route: '/pos' },
  { label: 'Check in', route: '/calendar' },
  { label: 'New guest', route: '/masters/customers?new=1' },
]
